function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { Modal, Button } from 'antd';
import { getProvider } from './providers/get-provider';
import { useGeneratedId } from '../../hooks/use-generated-id';
import { DEFAULT_FILE_TYPES, DEFAULT_IMAGE_DIMENSIONS } from './contants';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
var DEFAULT_PROVIDER = 'filepond';

var UploadBtnState = function UploadBtnState(props) {
  var _props$buttonIcon, _props$buttonText;

  return /*#__PURE__*/React.createElement("div", {
    className: "faux-btn"
  }, props.buttonIcon === null ? null : (_props$buttonIcon = props.buttonIcon) !== null && _props$buttonIcon !== void 0 ? _props$buttonIcon : /*#__PURE__*/React.createElement(PlusOutlined, null), props.buttonText === null ? null : (_props$buttonText = props.buttonText) !== null && _props$buttonText !== void 0 ? _props$buttonText : 'Upload');
};

var UploadedBtnState = function UploadedBtnState(_ref) {
  var _value$filename;

  var type = _ref.type,
      value = _ref.value,
      onRemove = _ref.onRemove,
      platformMode = _ref.platformMode;
  var handleRemove = React.useCallback(function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }, [type, value === null || value === void 0 ? void 0 : value.url, value === null || value === void 0 ? void 0 : value.filename]);
  return /*#__PURE__*/React.createElement("div", {
    className: "data"
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames('uploaded-item', _defineProperty({}, 'mv', platformMode === 'MOBILE'))
  }, type === 'image' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CloseOutlined, {
    onClick: function onClick(ev) {
      handleRemove(ev);
      onRemove();
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: value.url,
    alt: value.filename
  })) : /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(ev) {
      handleRemove(ev);
      onRemove();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames('uploaded-item-filename', _defineProperty({}, 'mv', platformMode === 'MOBILE'))
  }, (_value$filename = value.filename) !== null && _value$filename !== void 0 ? _value$filename : value.url), /*#__PURE__*/React.createElement(CloseOutlined, null))));
};

// @ts-ignore -- ignoring complaint about static exposed variables
var FileUploader = React.forwardRef(function (props) {
  var _props$provider, _props$defaultValue, _props$defaultValue2, _props$type, _props$value3, _props$platformMode;

  var id = useGeneratedId();

  var _React$useState = React.useState((_props$provider = props.provider) !== null && _props$provider !== void 0 ? _props$provider : DEFAULT_PROVIDER),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      provider = _React$useState2[0];

  var _React$useState3 = React.useState(function () {
    return getProvider(provider);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      Provider = _React$useState4[0];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      visible = _React$useState6[0],
      setVisible = _React$useState6[1];

  var _React$useState7 = React.useState((_props$defaultValue = props.defaultValue) !== null && _props$defaultValue !== void 0 ? _props$defaultValue : props.value),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      defaultValue = _React$useState8[0],
      setDefaultValue = _React$useState8[1];

  var _React$useState9 = React.useState((_props$defaultValue2 = props.defaultValue) !== null && _props$defaultValue2 !== void 0 ? _props$defaultValue2 : props.value),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      currentValue = _React$useState10[0],
      setCurrentValue = _React$useState10[1];

  var fileType = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'image';
  var isImageMode = fileType === 'image';
  var handleSuccess = React.useCallback(function (value) {
    setVisible(false);
    setCurrentValue(value);
    setDefaultValue(value);
  }, []);
  var handleRemove = React.useCallback(function (value) {
    setCurrentValue(undefined);
    setDefaultValue(undefined);
  }, []);
  /**
   * Handle manual value updates
   */

  React.useEffect(function () {
    var _props$value, _props$value2;

    if ((_props$value = props.value) !== null && _props$value !== void 0 && _props$value.url && ((_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.url) !== (currentValue === null || currentValue === void 0 ? void 0 : currentValue.url)) {
      setCurrentValue(props.value);

      if (!props.defaultValue || props.value !== props.defaultValue) {
        setDefaultValue(props.value);
      }
    }
  }, [(_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.url]);
  var platformMode = (_props$platformMode = props.platformMode) !== null && _props$platformMode !== void 0 ? _props$platformMode : 'STANDARD';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: classnames('sw-file-uploader-btn', provider, 'ant-upload', 'ant-upload-select', 'ant-upload-select-picture-card', "".concat(fileType, "-mode"), props.className, {
      'showing-upload': currentValue,
      disabled: props.disabled
    }),
    onClick: function onClick() {
      return setVisible(true);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames('ant-upload', 'contents', {
      'show-upload': currentValue
    }),
    role: "button"
  }, !!currentValue ? /*#__PURE__*/React.createElement(UploadedBtnState, {
    type: props.type,
    value: currentValue,
    onRemove: function onRemove() {
      var _props$onRemove, _props$onChange;

      handleRemove();
      (_props$onRemove = props.onRemove) === null || _props$onRemove === void 0 ? void 0 : _props$onRemove.call(props);
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props);
    },
    platformMode: platformMode
  }) : /*#__PURE__*/React.createElement(UploadBtnState, {
    buttonIcon: props.buttonIcon,
    buttonText: props.buttonText
  }))), /*#__PURE__*/React.createElement(Modal, {
    className: classnames('sw-file-uploader-modal', provider, "".concat(fileType, "-mode"), props.modalClassName),
    destroyOnClose: true,
    visible: !props.disabled && visible,
    onCancel: function onCancel() {
      setVisible(false);
    },
    footer: false
  }, visible && /*#__PURE__*/React.createElement(Provider.Component, {
    id: id,
    type: props.type,
    allowedMimeTypes: props.allowedMimeTypes,
    defaultValue: isImageMode ? defaultValue : undefined,
    value: isImageMode ? props.value : undefined,
    ownerType: props.ownerType,
    ownerId: props.ownerId,
    ownerIcon: props.ownerIcon,
    platformMode: platformMode,
    "private": props["private"],
    imageConfig: props.imageConfig,
    onChange: props.onChange,
    handleClose: function handleClose() {
      return setVisible(false);
    },
    onSuccess: function onSuccess(value) {
      var _props$onSuccess;

      handleSuccess(value);
      (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, value);
    },
    onRemove: function onRemove(value) {
      var _props$onRemove2, _props$onChange2;

      handleRemove(value);
      (_props$onRemove2 = props.onRemove) === null || _props$onRemove2 === void 0 ? void 0 : _props$onRemove2.call(props, value);
      (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props);
    },
    onError: function onError(error) {
      if (error) {
        var _props$onError;

        (_props$onError = props.onError) === null || _props$onError === void 0 ? void 0 : _props$onError.call(props, error);
      }
    }
  })));
});
FileUploader.defaultFileTypes = DEFAULT_FILE_TYPES;
FileUploader.defaultDimensions = DEFAULT_IMAGE_DIMENSIONS;
export default FileUploader;